import Utils from "./utils";
import BoundingBox from 'models/boundingBox'

class DomUtils {
    /**
     * For the given classnames, figures out the bounding area of the classnames, 
     * and creates a JSON-string out of the list.
     * Will return null in case of any errors.
     * @param {[string]} classNames 
     * @return {null|string} 
     */
    getBoundingBoxListStrForClassNames(classNamesList, scrollTop) {
        if (Utils.isNull(scrollTop) === true) {
            scrollTop = 0
        }
        if (Utils.isNull(classNamesList) || classNamesList.length === 0) {
            return null
        }

        try {
            let boxList = []

            // Get the bounding box for every element in the list
            for (var nameIndex in classNamesList) {
                var name = classNamesList[nameIndex];
                var elementsList = document.getElementsByClassName(name);
                if (false === Utils.isNull(elementsList) && elementsList.length > 0) {
                    var element = elementsList.item(0)
                    var boundingBox = element.getBoundingClientRect()
                    var box = new BoundingBox(boundingBox.x, ((boundingBox.y) - scrollTop), boundingBox.width, boundingBox.height)
                    boxList.push(box)
                }
            }

            let boxListStr = JSON.stringify(boxList)
            return boxListStr
        } catch (err) {
            console.log("BOUNDING-BOX: Error finding bounding box for - ", classNamesList)
        }

        return null
    }

    getTopForElement(className) {
        var elementsList = document.getElementsByClassName(className);
        if (false === Utils.isNull(elementsList) && elementsList.length > 0) {
            var element = elementsList.item(0)
            var boundingBox = element.getBoundingClientRect()
            return boundingBox.y+boundingBox.width;
        }
    }
}

let instance = new DomUtils()
export default instance


// WEBPACK FOOTER //
// ./src/common/domUtils.js